// Ole Miss's undergraduate majors (#2748). Read on 2026-10-01 from the
// official 2026-2027 Academic Catalog's Programs page (catalog.olemiss.edu/
// programs/), whose program chart lists every program with the school that
// offers it and its degree: every bachelor's line kept; minors, certificates,
// concentrations and graduate programs left out. Names are the catalog's own,
// including its abbreviations ("Bus Analytics & Info Systems", "Rhetoric,
// Writing & Speech Comm") and its "(2+2)" and "(3+1)" tags on the health
// programs; the degree in parentheses moves to `degree`, as the catalog
// writes it. Quirks: the catalog lists Sociology (BS) twice and
// Interdisciplinary Studies as three entries (A, B and plain), kept here once
// each; General Business (BBA Online) is the online delivery of General
// Business (BBA) and is left out. The KB's majors list was the starting
// point; the catalog wins.
const majors =
{
    "slug": "university-of-mississippi",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Ole Miss's official 2026-2027 Academic Catalog, grouped by the school that offers it, with the degree it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Liberal Arts",
            "source": {
                "label": "Ole Miss 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.olemiss.edu/programs/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Allied Health Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Arabic",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry for Health Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Science",
                    "degree": "BA"
                },
                {
                    "name": "Biological Science",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Creative Writing",
                    "degree": "B.F.A."
                },
                {
                    "name": "Dental Hygiene (2+2)",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Film Production",
                    "degree": "BFA"
                },
                {
                    "name": "Forensic Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Health Info & Info Mgmt (2+2)",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Histotechnology (2+2)",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Medical Lab Science (3+1)",
                    "degree": "BS"
                },
                {
                    "name": "Medical Laboratory Science (2+2)",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BM"
                },
                {
                    "name": "Nursing (2+2)",
                    "degree": "BSN"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Policy Leadership",
                    "degree": "BA"
                },
                {
                    "name": "Radiologic Sciences (2+2)",
                    "degree": "BS"
                },
                {
                    "name": "Rhetoric, Writing & Speech Comm",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Southern Studies",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BA"
                },
                {
                    "name": "Theatre Arts",
                    "degree": "BFA"
                }
            ]
        },
        {
            "name": "School of Applied Sciences",
            "source": {
                "label": "Ole Miss 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.olemiss.edu/programs/"
            },
            "majors": [
                {
                    "name": "Communication Sciences & Disorders",
                    "degree": "BS"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "BSCJ"
                },
                {
                    "name": "Dietetics and Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Exercise Science",
                    "degree": "BSES"
                },
                {
                    "name": "Hospitality Management",
                    "degree": "BS"
                },
                {
                    "name": "Law Studies",
                    "degree": "BSLS"
                },
                {
                    "name": "Public Health",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Sport Management",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Business Administration",
            "source": {
                "label": "Ole Miss 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.olemiss.edu/programs/"
            },
            "majors": [
                {
                    "name": "Banking and Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Bus Analytics & Info Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "General Business",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Professional Sales",
                    "degree": "BBA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BBA"
                },
                {
                    "name": "Risk Management and Insurance",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "Patterson School of Accountancy",
            "source": {
                "label": "Ole Miss 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.olemiss.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BAccy"
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "Ole Miss 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.olemiss.edu/programs/"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "B.A.Ed."
                },
                {
                    "name": "Elementary Education",
                    "degree": "B.A.Ed."
                },
                {
                    "name": "English Education",
                    "degree": "B.A.Ed."
                },
                {
                    "name": "Health and Physical Education",
                    "degree": "B.A.Ed."
                },
                {
                    "name": "Mathematics Education",
                    "degree": "B.A.Ed."
                },
                {
                    "name": "Science Education",
                    "degree": "B.A.Ed."
                },
                {
                    "name": "Social Studies Education",
                    "degree": "B.A.Ed."
                },
                {
                    "name": "Special Education",
                    "degree": "B.A.Ed."
                }
            ]
        },
        {
            "name": "School of Engineering",
            "source": {
                "label": "Ole Miss 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.olemiss.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "BSBE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSCHE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSCPE"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BSCS"
                },
                {
                    "name": "Data Science",
                    "degree": "BSDS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEE"
                },
                {
                    "name": "Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Geological Engineering",
                    "degree": "BSGE"
                },
                {
                    "name": "Geology",
                    "degree": "BSG"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                }
            ]
        },
        {
            "name": "School of Journalism and New Media",
            "source": {
                "label": "Ole Miss 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.olemiss.edu/programs/"
            },
            "majors": [
                {
                    "name": "Integrated Mktg. Communications",
                    "degree": "BS"
                },
                {
                    "name": "Journalism",
                    "degree": "BAJ"
                },
                {
                    "name": "Media Communication",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "School of Pharmacy",
            "source": {
                "label": "Ole Miss 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.olemiss.edu/programs/"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "BSPS"
                }
            ]
        },
        {
            "name": "University Programs",
            "source": {
                "label": "Ole Miss 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.olemiss.edu/programs/"
            },
            "majors": [
                {
                    "name": "Multi-Disciplinary Studies",
                    "degree": "BMDS"
                },
                {
                    "name": "University Studies",
                    "degree": "BUS"
                }
            ]
        }
    ]
};

export default majors;
